<template>
    <div id="form-star-rating">
        <div :class="`form-star-rating start-align-${localAlign}`">
            <input
                type="text"
                class="form-star-rating-title"
                v-model="localFieldLabel"
                @blur="updateField"
                placeholder="Bir soru girin"
            />
            <div class="stars">
                <span v-for="star in 5" :key="star" :class="{ selected: star <= localRating }" @click="setRating(star)">
                    ★
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "form-star-rating",
    props: {
        fieldLabel: String,
        align: String,
        item: Object,
    },
    data() {
        return {
            localFieldLabel: this.fieldLabel || "",
            localAlign: this.align || "",
            localRating: 0,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateField() {
            const updateFields = {
                label: this.localFieldLabel,
                starRating: {
                    fieldLabel: this.localFieldLabel,
                    rating: this.localRating,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields: updateFields,
            });
            this.$emit("update-field", updateFields);
        },
        setRating(star) {
            this.localRating = star;
            this.updateField();
        },
    },
    watch: {
        fieldLabel(newVal) {
            this.localFieldLabel = newVal;
        },
        align(newVal) {
            this.localAlign = newVal;
        },
    },
};
</script>

<style scoped lang="scss">
#form-star-rating {
    .start-align-left {
        flex-direction: initial !important;

        .form-star-rating-title {
            width: auto !important;
            text-align: left;
            margin-right: 10px;
        }
    }

    .start-align-right {
        flex-direction: initial !important;

        .form-star-rating-title {
            width: auto !important;
            text-align: right;
            margin-right: 10px;
        }
    }

    .form-star-rating {
        cursor: all-scroll;
        display: flex;
        flex-direction: column;
        margin: 20px 0;

        .form-star-rating-title {
            display: block;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 8px;
            border: none;
            padding: 4px;
            width: 100%;
        }

        .stars {
            display: flex;
            gap: 5px;

            span {
                font-size: 2em;
                cursor: pointer;
                color: #ccc;
                transition: color 0.3s ease;

                &.selected {
                    color: gold;
                }

                &:hover {
                    color: gold;
                }
            }
        }
    }
}
</style>
